if (!customElements.get('ta-deep-sky-product-categories')) {
  class DeepSkyProductCategories extends HTMLElement {
    connectedCallback() {
      this.activeCategory = this.dataset.activeCategory;
      this.handleClick = this.onClick.bind(this);
      this.handleUpdate = this.syncFromUrl.bind(this);
      this.addEventListener('click', this.handleClick);
      window.addEventListener('popstate', this.handleUpdate);
      document.addEventListener('on:facet-filters:updated', this.handleUpdate);
      // The facet renderer restores only history entries with a state object.
      if (typeof window.history.state?.searchParams !== 'string') {
        window.history.replaceState({
          ...window.history.state,
          searchParams: window.location.search.slice(1)
        }, '', window.location.href);
      }
      this.syncFromUrl();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      window.removeEventListener('popstate', this.handleUpdate);
      document.removeEventListener('on:facet-filters:updated', this.handleUpdate);
    }

    setActive(category) {
      if (!this.querySelector(`[data-category="${CSS.escape(category)}"]`)) return;
      this.activeCategory = category;
      this.querySelectorAll('[data-category]').forEach((link) => {
        const active = link.dataset.category === category;
        link.classList.toggle('is-active', active);
        if (active) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }

    syncFromUrl() {
      const values = new URLSearchParams(window.location.search).getAll(this.dataset.filterParam);
      const selected = values.length === 1
        ? Array.from(this.querySelectorAll('a[data-category]')).find((link) => link.dataset.filterValue === values[0])
        : null;
      this.setActive(selected?.dataset.category || 'all');
    }

    async onClick(event) {
      const link = event.target.closest('a[data-category]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const facets = this.closest('.ta-deep-sky-products')?.querySelector('facet-filters');
      if (!facets?.applyFilters) return;
      event.preventDefault();
      if (this.pending) return;

      const previousCategory = this.activeCategory;
      const target = new URL(window.location.href);
      const params = new URLSearchParams(target.search);
      params.delete('page');
      params.delete('section_id');
      params.delete(this.dataset.filterParam);
      params.set('view', 'deep-sky-imaging');
      if (link.dataset.filterValue) params.set(this.dataset.filterParam, link.dataset.filterValue);
      target.search = params.toString();
      target.hash = 'deep-sky-popular-picks';
      this.pending = true;
      this.setAttribute('aria-busy', 'true');
      this.setActive(link.dataset.category);
      try {
        const updated = await facets.applyFilters(params.toString(), event, true);
        if (updated) {
          this.closest('.ta-deep-sky-products').querySelector('.ta-deep-sky-products__header')?.scrollIntoView({ block: 'start' });
        } else {
          this.setActive(previousCategory);
          window.location.assign(target.href);
        }
      } finally {
        this.pending = false;
        this.setAttribute('aria-busy', 'false');
      }
    }
  }
  customElements.define('ta-deep-sky-product-categories', DeepSkyProductCategories);
}
